import { render, staticRenderFns } from "./UnknownStudents.vue?vue&type=template&id=5a308bf1"
import script from "./UnknownStudents.vue?vue&type=script&lang=js"
export * from "./UnknownStudents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports